// extracted by mini-css-extract-plugin
module.exports = {"title":"SeasonTitle-module--title--16PAx","byline":"SeasonTitle-module--byline--o4NfT"};